import { useEffect, useState } from 'react';
import SlackBanner from './SlackBanner/SlackBanner';
import useActionStore from '../../../../store/Actions';
import useAuthStore from '../../../../store/Auth';

export default function Banner() {
  const { organization } = useAuthStore();
  const { showSidebarBanner, toggleShowSidebarBanner } = useActionStore();
  const [banner, setBanner] = useState('slack');
  const { hasSlackInstalled } = organization;

  const closeBanner = () => {
    toggleShowSidebarBanner(false);
  };

  const renderBanner = (banner: string) => {
    switch (banner) {
      case 'slack':
        return <SlackBanner />;

      default:
        return <SlackBanner />;
    }
  };

  useEffect(() => {
    if (
      organization &&
      Object.keys(organization).length !== 0 &&
      !hasSlackInstalled
    ) {
      toggleShowSidebarBanner(true);
      setBanner('slack');
    } else {
      toggleShowSidebarBanner(false);
    }
  }, [showSidebarBanner, hasSlackInstalled]);

  if (!showSidebarBanner) {
    return null;
  }

  return (
    <div className="border border-modal-stroke bg-navigation-tab-hover rounded-sm m-2 py-2 px-3 relative">
      <div
        onClick={closeBanner}
        className="w-fit flex justify-end items-end absolute top-1 right-1 text-text-primary-body hover:text-text-primary-heading transition-all duration-300 ease-in-out cursor-pointer"
      >
        <CloseIcon />
      </div>
      <div className="mt-3 mb-3">{renderBanner(banner)}</div>
    </div>
  );
}

const CloseIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.64258 12.3583L12.3592 7.6416"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.3592 12.3583L7.64258 7.6416"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
